import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import { api } from './api';
import { apiBulk } from './api.bulk';
import { apiTests } from './api.tests';
import { apiAdmin } from './api.admin';
import { apiUsers } from './api.user';
import { apiNotifications } from './api.notifications';
import { apiAutomations } from './api.automations';
import { apiGuides } from './api.guides';
import { apiJira } from './api.jira';
import { healthApi } from './api.health';
import { automationApi } from './api.automation';
import { historyApi } from './api.history';
import { auditLogApi } from './api.auditLog';

import userSlice from './reducers/user.slice';
import uiSlice from './reducers/ui.slice';
import { apiAem } from './api.aem';
import { apiDocumentation } from './api.documentation';
import { apiEmbargoKeyword } from './api.embargoKeyword';
import { apiImageExceptions } from './api.imageException';
import { apiUrlExceptions } from './api.urlException';
import { apiSkuChecker } from './api.skuChecker';

const middlewares = [
  api.middleware,
  apiBulk.middleware,
  apiTests.middleware,
  apiAdmin.middleware,
  apiNotifications.middleware,
  apiAutomations.middleware,
  apiGuides.middleware,
  apiUsers.middleware,
  apiAem.middleware,
  apiDocumentation.middleware,
  apiJira.middleware,
  healthApi.middleware,
  auditLogApi.middleware,
  automationApi.middleware,
  historyApi.middleware,
  apiEmbargoKeyword.middleware,
  apiUrlExceptions.middleware,
  apiImageExceptions.middleware,
  apiSkuChecker.middleware
];

export const setupStore = configureStore({
  reducer: {
    user: userSlice,
    ui: uiSlice,
    [api.reducerPath]: api.reducer,
    [apiBulk.reducerPath]: apiBulk.reducer,
    [apiTests.reducerPath]: apiTests.reducer,
    [apiAdmin.reducerPath]: apiAdmin.reducer,
    [apiUsers.reducerPath]: apiUsers.reducer,
    [apiNotifications.reducerPath]: apiNotifications.reducer,
    [apiAutomations.reducerPath]: apiAutomations.reducer,
    [apiGuides.reducerPath]: apiGuides.reducer,
    [apiAem.reducerPath]: apiAem.reducer,
    [apiDocumentation.reducerPath]: apiDocumentation.reducer,
    [apiJira.reducerPath]: apiJira.reducer,
    [healthApi.reducerPath]: healthApi.reducer,
    [auditLogApi.reducerPath]: auditLogApi.reducer,
    [automationApi.reducerPath]: automationApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
    [apiEmbargoKeyword.reducerPath]: apiEmbargoKeyword.reducer,
    [apiUrlExceptions.reducerPath]: apiUrlExceptions.reducer,
    [apiImageExceptions.reducerPath]: apiImageExceptions.reducer,
    [apiSkuChecker.reducerPath]: apiSkuChecker.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares)
});

export type AppDispatch = typeof setupStore.dispatch;
export type RootState = ReturnType<typeof setupStore.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default setupStore;
